import ChatConfig from '../../pages/ChatConfig';
import Dashboard from '../../pages/Dashboard';
import DataManagement from '../../pages/DataManagement';
import Documents from '../../pages/Documents';
import FAQs from '../../pages/FAQs';
import EmbeddingConfig from '../../pages/EmbeddingConfig';
import Users from '../../pages/Users';
import Settings from '../../pages/Settings';
import TextExtractionConfig from '../../pages/TextExtractionConfig';
import DocumentSourceConfig from '../../pages/DocumentSourceConfig';
import DocumentSourceConnections from '../../pages/DocumentSourceConnections';
import SharedFolders from '../../pages/SharedFolders';
import { GroupManagement } from '../../pages/GroupManagement';
import SystemManagement from '../../pages/SystemManagement';

export interface RouteConfig {
  path: string;
  component: React.ComponentType;
  permission?: string;
}

export const protectedRoutes: RouteConfig[] = [
  { path: '/dashboard', component: Dashboard },
  // Chat route is handled separately in AppRoutes.tsx for custom layout
  { path: '/documents', component: Documents },
  { path: '/shared-folders', component: SharedFolders },
  { path: '/document-sources', component: DocumentSourceConnections },
  { path: '/faqs', component: FAQs },
  { path: '/settings', component: Settings },

  // Permission-based routes
  { path: '/users', component: Users, permission: 'users' },
  { path: '/groups', component: GroupManagement, permission: 'groups' },

  // Admin configuration routes
  { path: '/chat-config', component: ChatConfig, permission: 'chat_config' },
  { path: '/embedding-config', component: EmbeddingConfig, permission: 'embedding_config' },
  { path: '/text-extraction-config', component: TextExtractionConfig, permission: 'text_extraction_config' },
  { path: '/document-source-config', component: DocumentSourceConfig, permission: 'document_sources' },

  // Super admin routes
  { path: '/data-management', component: DataManagement, permission: 'data_management' },
  { path: '/system-management', component: SystemManagement, permission: 'system_management' },
];